import graphql__a0477f4efc2646bcd6b3 from "./__generated__/PageSectionSidebarEmbed_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import PageSectionSidebarBlock from "./PageSectionSidebarBlock";
import ButtonLink from "../Buttons/ButtonLink";
import RichText from "../Utils/RichText";
import VideoPlayer from "../Media/VideoPlayer";
import AudioPlayer from "../Media/AudioPlayer";

const PageSectionSidebarEmbed = props => {
  const pageSection = useFragment(PageSectionSidebarEmbed_pageSection, props.pageSection);
  const { title, description, code, hlsUrl, audio, iconClass, format, url, mediaTitle } =
    pageSection;
  const transcriptionUrl = pageSection.transcription?.url;

  const t = useFormatMessage();
  const transcriptionLabel = t(intlMessages.transcriptionLabel);

  // Convert stored format (ex: 16x9) to bootstrap-compatible format (ex: 16by9)
  //
  const hasFormat = format && format !== "default";
  const formatClassName = hasFormat && format.replace("x", "by");

  const contentClassName = classNames("line-height-none", {
    "border-radius-top": !title && !description,
    "embed-responsive": hasFormat,
    ["embed-responsive-" + formatClassName]: hasFormat
  });

  const isVideoPlayer = hlsUrl;
  const isEmbedCode = !hlsUrl && code;
  const isURL = !hlsUrl && url;
  const isAudioPlayer = !hlsUrl && audio?.url;

  return (
    <PageSectionSidebarBlock
      title={title}
      description={description}
      iconClassName={iconClass}
    >
      {isVideoPlayer && <VideoPlayer withVideoStream={pageSection} />}
      {isEmbedCode && <RichText className={contentClassName} content={code} />}
      {isURL && (
        <div className={contentClassName}>
          <iframe title={mediaTitle} src={url} />
        </div>
      )}

      {isAudioPlayer && <AudioPlayer audio={audio} />}

      {transcriptionUrl && (
        <ButtonLink
          href={transcriptionUrl}
          className="page-section-embed-transcription btn btn-default btn-sm full-width"
          label={transcriptionLabel}
          iconClassName="icon-document"
          target="_blank"
        />
      )}
    </PageSectionSidebarBlock>
  );
};

const PageSectionSidebarEmbed_pageSection = graphql__a0477f4efc2646bcd6b3;

export default PageSectionSidebarEmbed;

const intlMessages = defineMessages({
  transcriptionLabel: {
    id: "pageSection.embed.transcriptionLabel",
    defaultMessage: "Télécharger la transcription textuelle du média"
  }
});
